import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { UtilsService } from 'src/app/shared/utils/utils.service'; 
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { AplicacionFrontModel } from '../../../model/aplicacionFrontModel';
import { AplicacionModel } from '../../../model/aplicacionModel';
import { ClaveValorModel } from '../../../model/claveValorModel';
import { DataLoginModel } from '../../../model/dataLoginModel';
import { TipoAplicacionModel } from '../../../model/tipoAplicacionModel';
import { AplicacionService } from '../../../services/aplicacion.service';
import { TipoAplicacionService } from '../../../services/tipoAplicacion.service';

@Component({
  selector: 'app-aplicacion',
  templateUrl: './aplicacion.component.html',
  styleUrls: ['./aplicacion.component.css']
})
export class AplicacionComponent implements OnInit {

  dataUsuario: DataLoginModel;
  mostrarFormulario: boolean = false;
  listaVacia: boolean = false;
  resposiveFull: string;
  uniformeModulo: any = {};

  formulario: FormGroup;
  formularioEditar: FormGroup;
  loading: boolean = false;

  textoBuscar: string;
  columnDefs: any[];
  rowData: AplicacionModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  seletedAplicacion: AplicacionModel;
  cmbTipoApp: ClaveValorModel[] = [];

  constructor(private fb: FormBuilder, private _util: UtilsService,
              private _aplicacion: AplicacionService, private _tipoApp: TipoAplicacionService) { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.uniformeModulo = uniformeModulo;
    this.resposiveFull = this.uniformeModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      tipoApp: ['',[Validators.required]],
      appDesc: ['',[Validators.required]],
    });

    this.formularioEditar = this.fb.group({
      tipoApp: ['',[Validators.required]],
      appDesc: ['',[Validators.required]],
    });

    this.cargarGrid();
    this.getAllAplicacionRow();
    this.buscarTipoAplicacion();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Aplicación',
        field: 'appDesc',
        filter: true,
        width: 235,
      },
      {
        headerName: 'Tipo de Documento',
        field: 'tipoApp.tipoDesc',
        filter: true,
        width: 235,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.callEditarAplicacion.bind(this),
          label: "Editar",
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.deleteAplicacion.bind(this),
          label: "Eliminar",
        }
      },
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllAplicacionRow() {
    this.loading = true;
    this._aplicacion.getAllAplicacion().subscribe((res:AplicacionModel[])=>{
      this.loading = false;
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    },(err)=>{
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.mesaage);
    });
  }

  buscarTipoAplicacion(){
    this.cmbTipoApp = [];
    this._tipoApp.getAllTipoAplicacion().subscribe((res:TipoAplicacionModel[])=>{
      res.forEach((item)=>{
        this.cmbTipoApp.push({clave: item.tipoId.toString(), valor: item.tipoDesc});
      });
    },(err)=>{
      console.log(err);
      this.cmbTipoApp = [];
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  convertFromToAppModel(){
    let item = new AplicacionFrontModel();
    item.appDesc = this.formulario.get('appDesc').value;
    item.tipoApp = Number(this.formulario.get('tipoApp').value);
    return item;
  }

  crearAplicacion(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar la siguiente Aplicación?',
        text: '',
        action: 'Guardar',
        funcion: this._aplicacion.createAplicacion(this.convertFromToAppModel()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getAllAplicacionRow();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callEditarAplicacion(event){
    this.seletedAplicacion = event.rowData;
    
    this.formularioEditar.get('appDesc').setValue(this.seletedAplicacion.appDesc);
    this.formularioEditar.get('tipoApp').setValue(this.seletedAplicacion.tipoApp.tipoId.toString());

    document.getElementById('abrirModalEditar').click();
  }

  convertFromToAppModelUp(){
    let item = new AplicacionFrontModel();
    item.appDesc = this.formularioEditar.get('appDesc').value;
    item.tipoApp = Number(this.formularioEditar.get('tipoApp').value);
    item.appId = this.seletedAplicacion.appId;
    return item;
  }

  updateAplicacion(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea actualizar la siguiente Aplicación?',
        text: '',
        action: 'Editar',
        funcion: this._aplicacion.updateAplicacion(this.convertFromToAppModelUp()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllAplicacionRow();
      this.seletedAplicacion = new AplicacionModel();
      document.getElementById('cerrarModalEditar').click();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  deleteAplicacion({rowData}){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar la siguiente Aplicación?',
        text: '',
        action: 'Eliminar',
        funcion: this._aplicacion.deleteAplicacion(Number(decodeURI(rowData.appId))),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllAplicacionRow();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

}
